import React from 'react'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton'

import { useQuery } from '~/client/hooks/cqrpc'
import Link from '~/client/components/Link'
import Heading from '~/client/components/Heading'
import SideNote from '~/client/components/SideNote'
import AppIcon from '~/client/components/AppIcon'

export default function Page() {
  return <Container>
    <Heading my={2} variant="main">DataPal Apps</Heading>
    <SideNote>
      Apps are the software supported processes and utilities
      that help you gather and use your data, all under your control.
    </SideNote>
    <PublicAppsList/>
  </Container>
}

function PublicAppsList(){
  const { result: apps = [], loading, error } = useQuery('apps.getPublic')
  return <Box sx={{
    mt: 2,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
  }}>
    {loading
      ? Array(4).fill().map((_, i) =>
        <Skeleton
          key={i}
          variant="rounded"
          height={50}
        />
      )
      : apps.map(app =>
        <Stack key={app.id} direction="row">
          {/*<InspectObject object={app}/>*/}
          <Link to={`/apps/${app.host}`} sx={{display: 'block', mr: 2}}>
            <AppIcon app={app}/>
          </Link>
          <Stack direction="column">
            <Link to={`/apps/${app.host}`}>{app.name}</Link>
            <Typography variant="body2">{app.description}</Typography>
          </Stack>
        </Stack>
      )
    }
  </Box>
}
